export const DEFAULT_NODE = [
  {
    id: '1',
    name: 'Home',
    url: '/'
  }
]
